import React, { useState } from 'react';

// 1. We store the data here so it's easy for you to edit later
const faqData = [
  {
    question: "Are all your products original?",
    answer: "Yes! All new items in our store are 100% original and are sourced directly from manufacturers' verified suppliers."
  },
  {
    question: "Do you deliver across Nigeria?",
    answer: "Yes, we deliver nationwide! Please note that delivery time and cost vary by location. We ensure Lagos orders are delivered within 24 hours, while other locations typically take 2-5 days depending on the distance. Customers can easily track their orders using the tracking number provided on our website."
  },
  {
    question: "Do you sell preowned items too?",
    answer: "Yes, we do. Furthermore, we make sure all preowned/used items undergo strict quality checks. Everything is verified to be working perfectly and accurately labeled before it is put up for sale."
  },
  {
    question: "Do you offer after-sales services and repairs?",
    answer: "Yes, we do. We have a team of competent and experienced technicians on ground to help repair faulty items and provide you with reliable after-sales support."
  }
];

// 2. The individual accordion item component
const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-gray-200 last:border-none">
      <button
        className="flex w-full items-center justify-between py-5 text-left text-gray-800 hover:text-blue-600 focus:outline-none transition-colors duration-200"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="text-lg font-medium">{question}</span>
        {/* Chevron Icon that rotates smoothly */}
        <svg
          className={`w-5 h-5 transform transition-transform duration-300 ${
            isOpen ? "rotate-180 text-blue-600" : "text-gray-500"
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      
      {/* Smoothly expanding answer container */}
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-96 opacity-100 pb-5" : "max-h-0 opacity-0"
        }`}
      >
        <p className="text-gray-600 leading-relaxed pr-4">
          {answer}
        </p>
      </div>
    </div>
  );
};

// 3. The main FAQ Section component
const FAQSection = () => {
  return (
    <section className="bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        
        {/* Header Message */}
        <div className="text-center mb-10">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600 italic">
            Welcome! We want to make your shopping experience as smooth and transparent as possible. 
            Below are answers to some of the most common questions we receive.
          </p>
        </div>

        {/* FAQ Accordion List */}
        <div className="bg-white rounded-xl shadow-md p-6 sm:p-8">
          {faqData.map((faq, index) => (
            <FAQItem key={index} question={faq.question} answer={faq.answer} />
          ))}
        </div>

        {/* Footer Message */}
        <div className="mt-10 text-center bg-blue-50 rounded-lg p-6 border border-blue-100">
          <h3 className="text-xl font-semibold text-blue-800 mb-2">
            Still have questions?
          </h3>
          <p className="text-blue-600">
            Our customer support team is always here to help. Contact us today and we will be happy to assist you!
          </p>
          <button className="mt-4 px-6 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors duration-200">
            Contact Support
          </button>
        </div>

      </div>
    </section>
  );
};

export default FAQSection;